import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

import {
  IconCheckbox01,
  IconCheckbox02,
  IconCheckbox03,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

interface IProps {
  className: string;
}

export const Box = styled.label<IProps>`
  position: relative;
  transition: opacity 0.3s;
  ${mixin.flex({
    display: 'inline-flex',
    justify: 'flex-start',
    align: 'center',
  })}

  input[type='checkbox']:disabled + .label,
  input[type='checkbox']:disabled + .chk-inner {
    opacity: 0.5;
  }

  input[type='checkbox']:checked + .chk-inner {
    &.chk-inner1 {
      rect {
        fill: #000 !important;
        stroke: #000 !important;
      }
    }

    &.chk-inner2 {
      path {
        fill: #000;
      }
    }

    &.chk-inner3 {
      circle:last-child {
        fill: #000;
      }
    }
  }

  &.check-type2 .label {
    font-size: 14px;
    line-height: 20px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.check-type2 .label {
      font-size: ${mixin.pxToVw('14')};
      line-height: ${mixin.pxToVw('20')};
    }
  }
`;

export const Input = styled.input`
  ${mixin.a11y()};
`;

export const ChkInner = styled(IconCheckbox01)`
  flex: none;
  display: inline-block;
  width: 20px;
  height: 20px;

  * {
    transition: all 0.1s;
  }

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('20')};
    height: ${mixin.pxToVw('20')};
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 22px;
    height: 22px;

    svg {
      width: 22px;
      height: 22px;
    }
  }
`;

export const ChkInner02 = styled(IconCheckbox02)`
  display: inline-block;
  width: ${mixin.pxToVw('17')};
  height: ${mixin.pxToVw('16')};

  @media ${({ theme }) => theme.media.sm} {
    width: 17px;
    height: 16px;
  }
`;

export const ChkInner03 = styled(IconCheckbox03)`
  flex: none;
  display: inline-block;
  width: 20px;
  height: 20px;

  * {
    transition: all 0.1s;
  }

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('20')};
    height: ${mixin.pxToVw('20')};
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 22px;
    height: 22px;

    svg {
      width: 22px;
      height: 22px;
    }
  }
`;

export const Label = styled.span`
  display: inline-block;
  font-size: 15px;
  line-height: 130%;
  margin: 0 8px;
  color: #000;

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('15')};
    margin: ${mixin.pxToVw('0 8')};
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 16px;
  }
`;
